import React from "react";
import { ContainerScroll } from "../../../ui/container-scroll-animation";
import { motion } from "framer-motion";
import {
  downAndUp,
  scrollVariantsLeft,
  scrollVariantsRight,
} from "../../../../constants/TextAnimation";
import { Spotlight } from "../../../ui/spotlight-new";
import { StickyScroll } from "../../../ui/sticky-scroll-reveal";
import { user1, user2, user3, user4 } from "../../../../assets";
import { cn } from "../../../../lib/utils";
import { Grid } from "../../../ui/Grid";

const content = [
  {
    title: "Collaborative Editing ",
    description:
      "Work together in real time with your team, clients, and stakeholders. Collaborate on documents, share ideas, and make decisions quickly. With our platform, you can streamline your workflow and increase productivity.",
    content: (
      <div className="flex h-full w-full items-center justify-center text-white">
        <img
          src={user1}
          width={300}
          height={300}
          className="h-full w-full object-cover"
          alt="linear board demo"
        />
      </div>
    ),
  },
  {
    title: "Real time changes",
    description:
      "See changes as they happen. With our platform, you can track every modification in real time. No more confusion about the latest version of your project. Say goodbye to the chaos of version control and embrace the simplicity of real-time updates.",
    content: (
      <div className="flex h-full w-full items-center justify-center text-white">
        <img
          src={user2}
          width={300}
          height={300}
          className="h-full w-full object-cover"
          alt="linear board demo"
        />
      </div>
    ),
  },
  {
    title: "Version control",
    description:
      "Experience real-time updates and never stress about version control again. Our platform ensures that you're always working on the most recent version of your project, eliminating the need for constant manual updates. Stay in the loop, keep your team aligned, and maintain the flow of your work without any interruptions.",
    content: (
      <div className="flex h-full w-full items-center justify-center text-white">
        <img
          src={user4}
          width={300}
          height={300}
          className="h-full w-full object-cover"
          alt="linear board demo"
        />
      </div>
    ),
  },
  {
    title: "Running out of content",
    description:
      "Experience real-time updates and never stress about version control again. Our platform ensures that you're always working on the most recent version of your project, eliminating the need for constant manual updates. Stay in the loop, keep your team aligned, and maintain the flow of your work without any interruptions.",
    content: (
      <div className="flex h-full w-full items-center justify-center text-white">
        <img
          src={user3}
          width={300}
          height={300}
          className="h-full w-full object-cover"
          alt="linear board demo"
        />
      </div>
    ),
  },
];

const TaxConsulting = () => {
  return (
    <motion.div
      initial={{ opacity: 0.0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        delay: 0.3,
        duration: 0.8,
        ease: "easeInOut",
      }}
      className="relative px-4 "
    >
      <div
        className={cn(
          "absolute inset-0 z-[-1]",
          "[background-size:40px_40px]",
          // "[background-image:linear-gradient(to_right,#e4e4e7_1px,transparent_1px),linear-gradient(to_bottom,#e4e4e7_1px,transparent_1px)]",
          "[background-image:linear-gradient(to_right,#262626_1px,transparent_1px),linear-gradient(to_bottom,#262626_1px,transparent_1px)]",
          "opacity-25"
        )}
      />
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black)] bg-[var(--secondary-bg-color)]"></div>
      <Spotlight />
      <section className="container px-0">
        <div className="flex flex-col overflow-hidden">
          <ContainerScroll
            titleComponent={
              <>
                <h1 className="text-2xl md:text-4xl font-semibold  dark:text-white">
                  Strategic Tax Consulting for <br />
                  <span className="text-2xl md:text-[6rem] font-bold mt-1 leading-none ">
                    Sustainable Growth
                  </span>
                </h1>
              </>
            }
          >
            <img
              src="/images/ourExpertise/7.jpg"
              alt="hero"
              height={320}
              width={1400}
              className="mx-auto rounded-2xl object-cover h-full object-left-top"
              draggable={false}
            />
          </ContainerScroll>
        </div>
      </section>

      <section className="container mt-[-8rem]">
        <motion.h6
          initial="hidden"
          whileInView="visible"
          variants={scrollVariantsRight}
          viewport={{ amount: 0.3 }}
          className="font-semibold text-white pb-8"
        >
          <span className="relative inline-block text-white text-lg md:text-2xl uppercase tracking-wide">
            Core Services
            {/* Gradient underline like ::before */}
            <span className="absolute left-1 bottom-[-0.625rem] w-full h-1 rounded-[3.125rem] bg-gradient-to-r from-secondary to-gold" />
          </span>
        </motion.h6>
        {/* Icon Blocks */}
        <motion.div
          variants={scrollVariantsLeft}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          className="max-w-[85rem] py-10 lg:py-14 mx-auto"
        >
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 items-center gap-12">
            {/* Icon Block */}
            <div className="p-3 bg-slate-900 rounded-lg relative">
              <Grid size={23} />
              <svg
                className="shrink-0 size-9 text-gray-200"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect width="10" height="14" x="3" y="8" rx="2" />
                <path d="M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4" />
                <path d="M8 18h.01" />
              </svg>
              <div className="bg-linear-to-r from-gray-200 via-gray-50 to-transparent h-0.5 mt-6">
                <div className="bg-gray-400 w-9 h-0.5"></div>
              </div>
              <div className="mt-5">
                <h3 className="text-base leading-none font-semibold text-gray-100">
                  Corporate Tax Advisory
                </h3>
                <p className="mt-1 text-gray-400 text-sm">
                  Guidance on UAE corporate tax regulations, exemptions, and
                  compliance strategies to optimize your company’s tax position.
                </p>
              </div>
            </div>
            {/* End Icon Block */}

            {/* Icon Block */}
            <div className="p-3 bg-slate-900 rounded-lg relative">
              <Grid size={23} />
              <svg
                className="shrink-0 size-9 text-gray-200"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 7h-9" />
                <path d="M14 17H5" />
                <circle cx="17" cy="17" r="3" />
                <circle cx="7" cy="7" r="3" />
              </svg>
              <div className="bg-linear-to-r from-gray-200 via-gray-50 to-transparent h-0.5 mt-6">
                <div className="bg-gray-400 w-9 h-0.5"></div>
              </div>
              <div className="mt-5">
                <h3 className="text-base leading-none font-semibold text-gray-100">
                  VAT Registration & Filing
                </h3>
                <p className="mt-1 text-gray-400 text-sm">
                  Full assistance with VAT setup, reporting, and submission in
                  accordance with Federal Tax Authority (FTA) requirements.
                </p>
              </div>
            </div>
            {/* End Icon Block */}

            {/* Icon Block */}
            <div className="p-3 bg-slate-900 rounded-lg relative">
              <Grid size={23} />
              <svg
                className="shrink-0 size-9 text-gray-200"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
              </svg>
              <div className="bg-linear-to-r from-gray-200 via-gray-50 to-transparent h-0.5 mt-6">
                <div className="bg-gray-400 w-9 h-0.5"></div>
              </div>
              <div className="mt-5">
                <h3 className="text-base font-semibold text-gray-100 leading-none">
                  International & Cross-Border Tax Planning
                </h3>
                <p className="mt-1 text-gray-400 text-sm">
                  Structuring business operations to minimize liabilities while
                  maintaining global compliance.
                </p>
              </div>
            </div>
            {/* End Icon Block */}

            {/* Icon Block */}
            <div className="p-3 bg-slate-900 rounded-lg relative">
              <Grid size={23} />
              <svg
                className="shrink-0 size-9 text-gray-200"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5Z" />
                <path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1" />
              </svg>
              <div className="bg-linear-to-r from-gray-200 via-gray-50 to-transparent h-0.5 mt-6">
                <div className="bg-gray-400 w-9 h-0.5"></div>
              </div>
              <div className="mt-5">
                <h3 className="text-base font-semibold text-gray-100 leading-none">
                  Tax Audit & Compliance Support
                </h3>
                <p className="mt-1 text-gray-400 text-sm">
                  Preparation, documentation, and representation during tax
                  reviews or FTA audits to ensure accuracy and peace of mind.
                </p>
              </div>
            </div>
            {/* End Icon Block */}
          </div>
        </motion.div>
        {/* End Icon Blocks */}
      </section>

      <section className="container px-1 py-10 sm:py-16 lg:py-24">
        <motion.div
          variants={scrollVariantsLeft}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          className="max-w-5xl mx-auto text-center"
        >
          <h2 className="text-3xl font-bold leading-tight text-white sm:text-3xl mb-5 lg:text-4xl">
            Why Clients trust us
          </h2>
          <p className="max-w-6xl mx-auto mt-1 text-lg leading-relaxed text-gray-200">
            At <strong className="text-gold">Scan Global Holdings</strong>,
            trust is earned through strategy, consistency, and results. Our
            clients rely on us because we bring{" "}
            <strong className="text-gold">
              strategic capabilities that drive measurable impact
            </strong>{" "}
            across every venture from business setup and tax consulting to real
            estate and investment solutions. We operate with integrity,
            transparency, and foresight, ensuring each partnership is built on
            clarity and mutual success. Backed by a global network of experts,
            we transform complex challenges into growth opportunities,
            delivering confidence that every decision is guided by insight,
            experience, and genuine commitment to long-term value.
          </p>
        </motion.div>
        {/* <motion.div
          variants={scrollVariantsRight}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          className="w-full py-4"
        >
          <StickyScroll content={content} />
        </motion.div> */}
      </section>

      <section className="container  py-10 sm:py-16 lg:pb-24">
        <div className="grid items-center lg:grid-cols-12 gap-6 lg:gap-12">
          <div className="lg:col-span-4">
            {/* Stats */}
            <div className="lg:pe-6 xl:pe-12 relative">
              <p className="text-6xl font-bold leading-10 text-gold ">
                92%
                <span className="ms-1 inline-flex items-center gap-x-1 font-medium text-xs leading-4 rounded-full py-0.5 px-2 bg-neutral-600 text-neutral-300">
                  <svg
                    className="shrink-0 size-4"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="white"
                    viewBox="0 0 16 16"
                  >
                    <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708z" />
                  </svg>
                  +7% this month
                </span>
              </p>
              <p className="mt-2 sm:mt-3 text-neutral-100">
                of U.S. adults have bought from businesses using Space
              </p>
            </div>
            {/* End Stats */}
          </div>
          {/* End Col */}

          <div className="lg:col-span-8 relative lg:before:absolute lg:before:top-0 lg:before:-start-12 lg:before:w-px lg:before:h-full lg:before:bg-neutral-700">
            <motion.div
              initial="hidden"
              whileInView="visible"
              variants={downAndUp}
              viewport={{ amount: 0.3 }}
              className="grid gap-6 grid-cols-2 md:grid-cols-4 lg:grid-cols-3 sm:gap-8"
            >
              {/* Stats */}
              <div>
                <p className="text-3xl font-semibold text-gold">99.95%</p>
                <p className="mt-1 text-neutral-400 uppercase">
                  in fulfilling orders
                </p>
              </div>
              {/* End Stats */}

              {/* Stats */}
              <div>
                <p className="text-3xl font-semibold text-gold">2,000+</p>
                <p className="mt-1 text-neutral-400 uppercase">
                  partner with Preline
                </p>
              </div>
              {/* End Stats */}

              {/* Stats */}
              <div>
                <p className="text-3xl font-semibold text-gold">85%</p>
                <p className="mt-1 text-neutral-400 uppercase">
                  this year alone
                </p>
              </div>
              {/* End Stats */}
            </motion.div>
          </div>
          {/* End Col */}
        </div>
      </section>
    </motion.div>
  );
};

export default TaxConsulting;
